'use client';

import { useTranslations, useLocale } from 'next-intl';
import { Button } from '@/components/ui';
import { Link } from '@/components/ui';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

interface EventRegistrationCardProps {
  event: {
    id: string;
    slug: string;
    registration_opens?: string | null;
    registration_closes?: string | null;
  };
  participantCount?: number;
  maxParticipants?: number;
  canRegister: boolean;
  isRegistrationOpen: boolean;
  loadingParticipantCount?: boolean;
}

export function EventRegistrationCard({ event, canRegister }: EventRegistrationCardProps) {
  const t = useTranslations('Event');
  const locale = useLocale();

  if (!canRegister) return null;

  // Hidden on mobile — the sticky bottom bar handles the register CTA there
  return (
    <Link href={`/${locale}/event/${event.id}/${event.slug}/register`} className="hidden md:block">
      <Button
        size="lg"
        className="h-12 min-h-[3rem] w-full font-semibold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
      >
        {t('registration.registerButton')}
        <ArrowRightIcon className="ml-2 h-4 w-4 shrink-0" />
      </Button>
    </Link>
  );
}
